import React from 'react';

type Props = {
  size: number;
  title?: string;
  className?: string;
};

const ToggleSidebarIcon = ({ className, size, title }: Props) => {
  return (
    <svg
      className={className}
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      {title && <title>{title}</title>}
      <g fill="none" fillRule="evenodd">
        <path
          d="M18.028 9.2L16.5 10.805 21.47 16l-4.97 5.195 1.528 1.605L24.5 16zm-7 0L9.5 10.805 14.47 16 9.5 21.195l1.528 1.605L17.5 16z"
          fill="#909090"
        />
      </g>
    </svg>
  );
};

export default ToggleSidebarIcon;
